export enum TranslationModeEnum {
  PLACEHOLDER = 1,
  TOOLTIP,
  VIEWER,
  INSERT_VALUE,
  INSERT_VALUE_AND_REMOVE_TAGS,
  REMOVE_TAGS,
}
